module.exports = __webpack_public_path__ + "static/media/0009.cac41f61.jpg";